import { TranslateService } from '@ngx-translate/core';

import { JsonViewerPinnedField } from 'src/app/core/components/popups/json-viewer-dialog/json-viewer-dialog.component';

/**
 * Fields WAP-1378 asks to surface from `extra_metadata`, pinned above the full payload.
 *
 * ! Paths mirror the API response — see LogFacade::getUserActionLogExtraMetadata in
 * ! the backend. A path that stops matching only loses its pin; the field is still
 * ! rendered in the payload tree below.
 */
export function userActionLogExtraMetadataPinnedFields(
  translateService: TranslateService,
): JsonViewerPinnedField[] {
  return [
    {
      label: translateService.instant('user-action-log-metadata.error-message'),
      path: 'error.message',
    },
    {
      label: translateService.instant('user-action-log-metadata.stack-trace'),
      path: 'error.trace',
    },
    {
      label: translateService.instant('user-action-log-metadata.http-error'),
      path: 'ext_log.record.http_error_message',
    },
    {
      label: translateService.instant('user-action-log-metadata.curl-error'),
      path: 'ext_log.record.curl_error_message',
    },
    {
      label: translateService.instant('user-action-log-metadata.request-trace'),
      path: 'ext_log.record.request_log_trace',
    },
    {
      label: translateService.instant(
        'user-action-log-metadata.request-shards',
      ),
      path: 'ext_log.record.request_shards',
    },
  ];
}
